import React from "react";
import { Modal } from "react-bootstrap";
import useResource from "../../shared/useResource";
import { Status, date } from "../../shared/UI";
export default function HistoryModal({ id, onClose }) {
  const { data, loading, error, reload } = useResource(
    `comercial-app/actividades/${id}/historial`
  );
  return (
    <Modal show onHide={onClose} size="lg" centered scrollable>
      <Modal.Header closeButton>
        <Modal.Title>Historial de seguimientos</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Status loading={loading} error={error} onRetry={reload} />
        {data?.data?.map((r) => (
          <article className="history-item" key={r.id}>
            <small>
              {date(r.fecha_vencimiento)} · {r.usuario?.nombre}
            </small>
            <h3>
              {r.seguimiento_realizado?.descripcion ||
                r.estatus ||
                "Seguimiento"}
            </h3>
            <p>{r.notas_seguimiento || "Sin notas"}</p>
          </article>
        ))}
      </Modal.Body>
    </Modal>
  );
}
